import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { getSettings } from "@/lib/api";

/**
 * Injects third-party analytics/marketing tags configured in the admin
 * dashboard: GA4, Google Tag Manager, Meta Pixel, LinkedIn Insight (under
 * settings.analytics) plus the global Google AdSense script (settings.adsense_pub_id).
 * Nothing renders until an ID is saved — no hard-coded keys.
 */
export default function TrackingScripts() {
  const [cfg, setCfg] = useState(null);
  const [adsense, setAdsense] = useState(null);
  useEffect(() => {
    getSettings().then((s) => {
      setCfg(s?.analytics || {});
      setAdsense((s?.adsense_pub_id || "").trim() || null);
    }).catch(() => setCfg({}));
  }, []);
  if (!cfg) return null;
  const { ga4_id, gtm_id, meta_pixel_id, linkedin_partner_id } = cfg;

  return (
    <Helmet>
      {/* Skimlinks affiliate monetization (site-wide) */}
      <script async type="text/javascript" src="https://s.skimresources.com/js/309665X1798029.skimlinks.js" />
      {adsense && (
        <script
          async
          crossOrigin="anonymous"
          src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsense}`}
        />
      )}
      {ga4_id && (
        <>
          <script async src={`https://www.googletagmanager.com/gtag/js?id=${ga4_id}`} />
          <script>{`
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
            gtag('config', '${ga4_id}');
          `}</script>
        </>
      )}
      {gtm_id && (
        <script>{`
          (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
          })(window,document,'script','dataLayer','${gtm_id}');
        `}</script>
      )}
      {meta_pixel_id && (
        <script>{`
          !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
          n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
          n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
          t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
          document,'script','https://connect.facebook.net/en_US/fbevents.js');
          fbq('init', '${meta_pixel_id}'); fbq('track', 'PageView');
        `}</script>
      )}
      {linkedin_partner_id && (
        <script>{`
          _linkedin_partner_id = "${linkedin_partner_id}";
          window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
          window._linkedin_data_partner_ids.push(_linkedin_partner_id);
          (function(l){if(!l){window.lintrk=function(a,b){window.lintrk.q.push([a,b])};
          window.lintrk.q=[]}var s=document.getElementsByTagName("script")[0];
          var b=document.createElement("script");b.type="text/javascript";b.async=true;
          b.src="https://snap.licdn.com/li.lms-analytics/insight.min.js";
          s.parentNode.insertBefore(b,s);})(window.lintrk);
        `}</script>
      )}
    </Helmet>
  );
}
